'use strict';
document.addEventListener('DOMContentLoaded', function () {

  var STYLE_INACTIVE = 'width:32px;height:32px;display:flex;align-items:center;justify-content:center;border:1px solid rgba(248,243,236,0.1);color:rgba(248,243,236,0.3);background:transparent;border-radius:5px;cursor:pointer;padding:0;transition:all .2s;';
  var STYLE_ACTIVE   = 'width:32px;height:32px;display:flex;align-items:center;justify-content:center;border:1px solid rgba(212,168,67,0.5);color:#D4A843;background:rgba(212,168,67,0.06);border-radius:5px;cursor:pointer;padding:0;transition:all .2s;';

  var viewBtns       = document.querySelectorAll('.collection-view-btn');
  var collectionGrid = document.getElementById('collection-grid');

  function setActiveBtn(activeBtn) {
    viewBtns.forEach(function (b) {
      b.classList.remove('is-active');
      b.setAttribute('style', STYLE_INACTIVE);
    });
    activeBtn.classList.add('is-active');
    activeBtn.setAttribute('style', STYLE_ACTIVE);
  }

  if (viewBtns.length && collectionGrid) {
    viewBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var cols = btn.dataset.view;
        setActiveBtn(btn);
        collectionGrid.style.gridTemplateColumns = 'repeat(' + cols + ', minmax(0, 1fr))';
        try { localStorage.setItem('soul-rugs-view', cols); } catch(e) {}
      });
    });

    try {
      var saved = localStorage.getItem('soul-rugs-view');
      if (saved) {
        var target = document.querySelector('.collection-view-btn[data-view="' + saved + '"]');
        if (target) {
          setActiveBtn(target);
          collectionGrid.style.gridTemplateColumns = 'repeat(' + saved + ', minmax(0, 1fr))';
        }
      } else {
        var defaultActive = document.querySelector('.collection-view-btn.is-active');
        if (defaultActive) setActiveBtn(defaultActive);
      }
    } catch(e) {
      var defaultActive = document.querySelector('.collection-view-btn.is-active');
      if (defaultActive) setActiveBtn(defaultActive);
    }
  }

  var filtersToggle = document.getElementById('filters-toggle');
  var filtersPanel  = document.getElementById('collection-filters');
  if (filtersToggle && filtersPanel) {
    filtersToggle.addEventListener('click', function () {
      filtersPanel.classList.toggle('is-open');
    });
  }

  var sortSelect = document.getElementById('sort-select');
  if (sortSelect) {
    var params  = new URLSearchParams(window.location.search);
    var current = params.get('sort_by');
    if (current) sortSelect.value = current;
    sortSelect.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      window.location.href = url.toString();
    });
  }

});
